<template>
  <div style="background:#fff; padding:20px;">
    <div style="margin-bottom:20px;">
      <a-form layout="inline">
        <a-form-item label="公告标题">
          <a-input v-model="query.title" placeholder="请输入公告标题" allow-clear style="width:220px" />
        </a-form-item>
        <a-form-item label="展示端">
          <a-select v-model="query.displayTarget" placeholder="全部" allow-clear style="width:140px">
            <a-select-option :value="0">全部</a-select-option>
            <a-select-option :value="1">商家</a-select-option>
            <a-select-option :value="2">师傅</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" icon="search" @click="handleSearch">查询</a-button>
          <a-button icon="reload" style="margin-left:10px" @click="handleReset">重置</a-button>
          <a-button
            v-permission="'app:announcement:list'"
            type="primary"
            icon="plus"
            style="margin-left:10px"
            @click="handleAdd"
          >新增公告</a-button>
        </a-form-item>
      </a-form>
    </div>

    <a-table
      row-key="id"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="pagination"
      @change="handleTableChange"
    >
      <span slot="displayTarget" slot-scope="value">
        <a-tag :color="targetMeta[value].color">{{ targetMeta[value].text }}</a-tag>
      </span>
      <span slot="content" slot-scope="value" class="content-preview" :title="value">{{ value }}</span>
      <span slot="action" slot-scope="text, record">
        <a v-permission="'app:announcement:list'" @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a-popconfirm
          title="确定删除该公告吗？删除后小程序将不再展示"
          :disabled="deletingId !== null"
          @confirm="handleDelete(record.id)"
        >
          <a v-permission="'app:announcement:list'" style="color:red">
            {{ deletingId === record.id ? '删除中...' : '删除' }}
          </a>
        </a-popconfirm>
      </span>
    </a-table>

    <a-modal
      v-model="visible"
      :title="form.id ? '编辑公告' : '新增公告'"
      :confirm-loading="submitting"
      :width="680"
      @ok="handleOk"
    >
      <a-form-model :model="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="公告标题" required>
          <a-input v-model="form.title" :max-length="100" placeholder="请输入公告标题" />
        </a-form-model-item>
        <a-form-model-item label="公告内容" required>
          <a-textarea
            v-model="form.content"
            :max-length="5000"
            :auto-size="{ minRows: 6, maxRows: 14 }"
            placeholder="请输入公告内容"
          />
          <div class="word-count">{{ form.content.length }}/5000</div>
        </a-form-model-item>
        <a-form-model-item label="展示端" required>
          <a-radio-group v-model="form.displayTarget">
            <a-radio :value="0">全部</a-radio>
            <a-radio :value="1">商家</a-radio>
            <a-radio :value="2">师傅</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import {
  getAnnouncementPage,
  createAnnouncement,
  updateAnnouncement,
  deleteAnnouncement
} from '@/api'
import { retreatPageAfterDelete } from '@/utils/pagination'

export default {
  name: 'AnnouncementView',
  data() {
    return {
      data: [],
      loading: false,
      visible: false,
      submitting: false,
      deletingId: null,
      query: { title: '', displayTarget: undefined },
      form: { id: null, title: '', content: '', displayTarget: 0 },
      targetMeta: {
        0: { text: '全部', color: 'blue' },
        1: { text: '商家', color: 'green' },
        2: { text: '师傅', color: 'orange' }
      },
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
        showTotal: total => `共 ${total} 条`
      },
      columns: [
        { title: 'ID', dataIndex: 'id', width: 80 },
        { title: '公告标题', dataIndex: 'title', width: 240 },
        { title: '公告内容', dataIndex: 'content', scopedSlots: { customRender: 'content' } },
        { title: '展示端', dataIndex: 'displayTarget', width: 100, scopedSlots: { customRender: 'displayTarget' } },
        { title: '创建时间', dataIndex: 'createdAt', width: 180 },
        { title: '更新时间', dataIndex: 'updatedAt', width: 180 },
        { title: '操作', key: 'action', width: 140, scopedSlots: { customRender: 'action' } }
      ]
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      getAnnouncementPage({
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        title: this.query.title || undefined,
        displayTarget: this.query.displayTarget
      }).then(res => {
        const payload = (res && res.data) || {}
        this.data = payload.records || []
        this.pagination.total = payload.total || 0
      }).finally(() => {
        this.loading = false
      })
    },
    handleSearch() {
      this.pagination.current = 1
      this.loadData()
    },
    handleReset() {
      this.query = { title: '', displayTarget: undefined }
      this.pagination.current = 1
      this.loadData()
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadData()
    },
    handleAdd() {
      this.form = { id: null, title: '', content: '', displayTarget: 0 }
      this.visible = true
    },
    handleEdit(record) {
      this.form = {
        id: record.id,
        title: record.title || '',
        content: record.content || '',
        displayTarget: record.displayTarget
      }
      this.visible = true
    },
    handleDelete(id) {
      if (this.deletingId !== null) return
      this.deletingId = id
      deleteAnnouncement(id)
        .then(() => {
          this.$message.success('删除成功')
          retreatPageAfterDelete(this.pagination, this.data.length)
          this.loadData()
        })
        .finally(() => {
          this.deletingId = null
        })
    },
    handleOk() {
      const title = (this.form.title || '').trim()
      const content = (this.form.content || '').trim()
      if (!title) {
        this.$message.error('请输入公告标题')
        return
      }
      if (!content) {
        this.$message.error('请输入公告内容')
        return
      }
      this.submitting = true
      const body = { title, content, displayTarget: this.form.displayTarget }
      const request = this.form.id
        ? updateAnnouncement(this.form.id, body)
        : createAnnouncement(body)
      request.then(() => {
        this.$message.success('保存成功')
        this.visible = false
        this.loadData()
      }).finally(() => {
        this.submitting = false
      })
    }
  }
}
</script>

<style scoped>
.content-preview {
  display: inline-block;
  max-width: 420px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
.word-count {
  color: #999;
  line-height: 24px;
  text-align: right;
}
</style>
